<button mat-button color="primary" [routerLink]="['/reports/create']">New inspection</button>
<app-search-element *ngIf="smallWidget === false" (formSubmittedEvent)="search($event)"></app-search-element>
<mat-nav-list class="mat-nav-list-with-border" infiniteScroll infiniteScrollDistance="1" (scrolled)="getReports()">
	<div class="divider custom"><span>Warehouse Inspections</span></div>
	<mat-list-item *ngFor="let report of warehouseReports">
		<div class="mat-list-content" [routerLink]="['/reports/' + report.id + '/view']">
			<h4 matLine>{{ report.report_nr }}</h4>
			<a matLine>{{ report.created | datex:'DD-MM-YYYY' }}</a>
		</div>
		<ng-container *ngIf="report.color">
			<div class="tag" [style.background]="report.color"></div>
		</ng-container>
		<ng-container *ngIf="report.is_resolved">
			<mat-icon class="is_resolved">check_circle_outline</mat-icon>
		</ng-container>
		<button mat-icon-button color="white-no-border" [matMenuTriggerFor]="menu">
			<mat-icon>more_vert</mat-icon>
		</button>
		<mat-menu #menu="matMenu">
			<a mat-menu-item [routerLink]="['/reports/' + report.id + '/edit']">Edit</a>
      <a mat-menu-item *ngIf="report.type == 'warehouse'" (click)="reportsService.copyReport(report.id, 'red')">Copy Red</a>
      <a mat-menu-item *ngIf="report.type == 'warehouse'" (click)="reportsService.copyReport(report.id, 'orange')">Copy Red & Orange</a>
			<a mat-menu-item (click)="deleteReport(report.id)">Delete</a>
		</mat-menu>
	</mat-list-item>
	<div class="divider"><span>Pallet Inspections</span></div>
	<mat-list-item *ngFor="let report of palletReports">
		<div class="mat-list-content" [routerLink]="['/reports/' + report.id + '/view']">
			<h4 matLine>{{ report.report_nr }}</h4>
			<a matLine>{{ report.created | datex:'DD-MM-YYYY' }}</a>
		</div>
		<ng-container *ngIf="report.color">
			<div class="tag" [style.background]="report.color"></div>
		</ng-container>
		<ng-container *ngIf="report.is_resolved">
			<mat-icon class="is_resolved">check_circle_outline</mat-icon>
		</ng-container>
		<button mat-icon-button color="white-no-border" [matMenuTriggerFor]="menu">
			<mat-icon>more_vert</mat-icon>
		</button>
		<mat-menu #menu="matMenu">
			<a mat-menu-item [routerLink]="['/reports/' + report.id + '/edit']">Edit</a>
      <a mat-menu-item *ngIf="report.type == 'warehouse'" (click)="reportsService.copyReport(report.id, 'red')">Copy Red</a>
      <a mat-menu-item *ngIf="report.type == 'warehouse'" (click)="reportsService.copyReport(report.id, 'orange')">Copy Red & Orange</a>
			<a mat-menu-item (click)="deleteReport(report.id)">Delete</a>
		</mat-menu>
	</mat-list-item>
	<div class="divider"><span>Compliance Checklist</span></div>
	<mat-list-item *ngFor="let report of complianceReports">
		<div class="mat-list-content" [routerLink]="['/reports/' + report.id + '/view']">
			<h4 matLine>{{ report.report_nr }}</h4>
			<a matLine>{{ report.created | datex:'DD-MM-YYYY' }}</a>
		</div>
		<ng-container *ngIf="report.color">
			<div class="tag" [style.background]="report.color"></div>
		</ng-container>
		<ng-container *ngIf="report.is_resolved">
			<mat-icon class="is_resolved">check_circle_outline</mat-icon>
		</ng-container>
		<button mat-icon-button color="white-no-border" [matMenuTriggerFor]="menu">
			<mat-icon>more_vert</mat-icon>
		</button>
		<mat-menu #menu="matMenu">
			<a mat-menu-item [routerLink]="['/reports/' + report.id + '/edit']">Edit</a>
      <a mat-menu-item *ngIf="report.type == 'warehouse'" (click)="reportsService.copyReport(report.id, 'red')">Copy Red</a>
      <a mat-menu-item *ngIf="report.type == 'warehouse'" (click)="reportsService.copyReport(report.id, 'orange')">Copy Red & Orange</a>
			<a mat-menu-item (click)="deleteReport(report.id)">Delete</a>
		</mat-menu>
	</mat-list-item>
</mat-nav-list>
